var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1000004632(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38508 1.64496C9.27212 0.741416 10.7279 0.741416 11.6149 1.64496V1.64496C12.1327 2.1724 12.8755 2.41374 13.6045 2.29139V2.29139C14.8532 2.0818 16.0309 2.93747 16.2175 4.18983V4.18983C16.3264 4.92091 16.7854 5.55274 17.4471 5.88222V5.88222C18.5805 6.44662 19.0304 7.83113 18.4451 8.95396V8.95396C18.1035 9.60942 18.1035 10.3904 18.4451 11.0459V11.0459C19.0304 12.1687 18.5805 13.5532 17.4471 14.1176V14.1176C16.7854 14.4471 16.3264 15.0789 16.2175 15.81V15.81C16.0309 17.0624 14.8532 17.918 13.6045 17.7084V17.7084C12.8755 17.5861 12.1327 17.8274 11.6149 18.3549V18.3549C10.7279 19.2584 9.27212 19.2584 8.38508 18.3549V18.3549C7.86726 17.8274 7.12448 17.5861 6.39553 17.7084V17.7084C5.14682 17.918 3.96908 17.0624 3.78254 15.81V15.81C3.67364 15.0789 3.21458 14.4471 2.55293 14.1176V14.1176C1.41951 13.5532 0.969645 12.1687 1.55486 11.0459V11.0459C1.89648 10.3904 1.89648 9.60942 1.55486 8.95396V8.95396C0.969645 7.83113 1.41951 6.44662 2.55293 5.88222V5.88222C3.21458 5.55274 3.67364 4.92091 3.78254 4.18983V4.18983C3.96908 2.93747 5.14682 2.0818 6.39553 2.29139V2.29139C7.12448 2.41374 7.86726 2.1724 8.38508 1.64496V1.64496Z",
    fill: "url(#paint0_linear_3376_1145)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1471 19.8528C4.32357 19.7352 3.92161 18.9215 3.82357 18.5293L1.9118 22.941L5.44122 22.6469L7.35298 25.5881L9.26474 21.0293L7.6471 19.5587C7.1569 19.7058 5.97063 19.9705 5.1471 19.8528Z",
    fill: "url(#paint1_linear_3376_1145)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2941 19.8528C16.1177 19.7352 16.5196 18.9215 16.6177 18.5293L18.5294 22.941L15 22.6469L13.0882 25.5881L11.1765 21.0293L12.7941 19.5587C13.2843 19.7058 14.4706 19.9705 15.2941 19.8528Z",
    fill: "url(#paint2_linear_3376_1145)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69562 8.22244V6.95605H11.0615V14.1126H9.64787V8.22244H8.69562Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3376_1145",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 19.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB8C05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3376_1145",
    x1: 5.58827,
    y1: 18.5293,
    x2: 5.58827,
    y2: 25.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB8C05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3376_1145",
    x1: 14.8529,
    y1: 18.5293,
    x2: 14.8529,
    y2: 25.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB8C05"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000004632);
export default __webpack_public_path__ + "static/media/Group 1000004632.46e91b4bec6ebc896fe582ed682f74e0.svg";
export { ForwardRef as ReactComponent };